enum ProcessStatus {
  RUNNING = "RUNNING",
  SUCCEEDED = "SUCCEEDED",
  FAILED = "FAILED",
  UNKNOWN = "UNKNOWN"
}

export default ProcessStatus;
